import { HttpContextToken, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable, Injector } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from './auth/auth.service';
import { CustomSnackbarComponent } from './shared/custom-snackbar.component';

export const IGNORED_STATUSES = new HttpContextToken<number[]>(() => []);

@Injectable()
export class HandleErrorsInterceptor implements HttpInterceptor {
  private snackBar = inject(MatSnackBar);
  private injector = inject(Injector);

  /** URLs excluded from detailed error alert  */
  private excludedUrls = [];

  intercept<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    const ignoredStatuses = req.context.get(IGNORED_STATUSES);
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        // If Status is in the ignored list, just use the error custom im component (example: content-items.component 400 Error Deleting Item)
        if (ignoredStatuses?.includes(error.status)) {
          return throwError(() => error);
        }

        if (!this.checkIfExcluded(error.url ?? '')) {
          this.showDetailedHttpError(error);
        }
        return throwError(() => error);
      }),
    );
  }

  private checkIfExcluded(url: string) {
    for (const excludedUrl of this.excludedUrls) {
      if (url.includes(excludedUrl)) {
        return true;
      }
    }
    return false;
  }

  private showDetailedHttpError(error: HttpErrorResponse) {
    let message = 'Http Error: ' + error.status;
    let icon = 'warning';

    if (error.status === 404) {
      return; // don't show 404, Email not Found
    }

    if (error.status === 403) {
      if (!error.url?.startsWith('/Login/ResetPassword') && !error.url?.startsWith('/Login/ActivateAccount')) {
        message = "Access Denied: You don't have permission to access this resource.";
        icon = 'error';
        const authSvc = this.injector.get(AuthService, null);
        authSvc?.logout();
      } else {
        console.info('got response 403 but will not redirect to login dialog');
      }
    }

    this.snackBar.openFromComponent(CustomSnackbarComponent, {
      data: { icon, message, iconColor: '#ff0000' },
      duration: 7000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: ['snackbar-error'],
    });
  }
}
